<template>
  <div class="operationInformation">
    <title1 title="运行时间" subTitle="Electric Port Overview" />
    <div class="left-box-right-1-bottom">
      <div class="soc">
        <div class="bottom">
          <soc></soc>
        </div>
      </div>
      <div class="soh">

        <div class="bottom">
          <soh></soh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import soc from "./soc.vue";
import soh from "./soh.vue";
export default {
  components: {
    title1,
    soc,
    soh
  },
  data() {
    return {};
  },
  methods: {},
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.operationInformation {
  .left-box-right-1-bottom {
    display: flex;
    justify-content: space-between;
    .soc {
      width: 280px;
      height: 385px;
    }
    .soh {
      width: 280px;
      height: 385px;
      // background-color: gold;

    }
  }
}
</style>